import Axios from './axios';
const env = window.config;
export class ThemesApi {
    getThemesInfo() {
        return Axios.get(`${env.apiHost}/public/theme/findAll`);
    }
    editTheme(params) {
        return Axios.post('/api/system/theme/edit', params);
    }
}
